<template>
    <button class="search-param" :class="{active}" @click="$emit('select')">
        {{name}}
    </button>
</template>
<script>
    export default {
        name: "search_param",
        props:{
            name: String,
            active: Boolean
        }
    }
</script>

<style scoped lang="scss">
    button.search-param{
        height: 44px;
        padding: 0 16px;
        border-radius: 4px;
        background-color: rgba($text_gray, 0.12);
        color: $text_gray;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        &:not(:last-child){
            margin-right: 4px;
        }
        &:hover{
            background-color: rgba($text_gray, 0.24);
        }
        &.active{
            background-color: $blue;
            color: white;
        }
    }
</style>